import { Chip, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useContractActions } from "../../../sales_marketing/service/useContractActions";
import { CustomerBaseDto } from "../../types";

interface CBSubscriptionStatusProps {
    customer: CustomerBaseDto | null;
}

const CBSubscriptionStatus = ({ customer }: CBSubscriptionStatusProps) => {
    const [hasInProgressSubscription, setHasInProgressSubscription] = useState(false);
    const { getContractList } = useContractActions();
    const theme = useTheme();
    const { t } = useTranslation("customerbase");

    useEffect(() => {
        const fetchSubscriptions = async () => {
            if (customer?.cbCustomerId) {
                try {
                    const response = await getContractList({}, customer.cbCustomerId);
                    if (response && Array.isArray(response.content)) {
                        const hasInProgress = response.content.some(
                            (subscription: any) => subscription.status === "INPROGRESS"
                        );
                        setHasInProgressSubscription(hasInProgress);
                    }
                } catch (error) {
                    console.error("Error fetching subscriptions:", error);
                }
            }
        };

        fetchSubscriptions();
    }, [customer]);

    if (!hasInProgressSubscription) {
        return null;
    }

    return (
        <Chip
            label={t("tags.subscription")}
            sx={{
                color: "white",
                backgroundColor: theme.palette.success.main,
            }}
        />
    );
};

export default CBSubscriptionStatus;
